import React from "react";

const sequence = { current: 0 };

const nextSequence = () => {
  sequence.current += 1;
  return sequence.current;
};

/* React 17 has no useId. Never derive the id from the value it labels: sanitising
   is not injective, so two distinct values can collapse onto one id. */
export const useDomId = (namespace) => {
  const [id] = React.useState(() => `${namespace}-${nextSequence()}`);
  return id;
};

export default useDomId;
